import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchCustomerData, fetchCustomerMailAddresses, fetchCustomerPhoneNumbers } from 'src/api/customer/data';
import { fetchCustomerFeedback } from 'src/api/customer/feedback';
import {
    FETCH_CUSTOMER_DATA,
    FETCH_CUSTOMER_FEEDBACK,
    FETCH_CUSTOMER_MAIL_ADDRESSES,
    FETCH_CUSTOMER_PHONE_NUMBERS,
    requestCustomerData,
    requestCustomerDataFailure,
    requestCustomerDataSuccess,
    requestCustomerFeedback,
    requestCustomerFeedbackFailure,
    requestCustomerFeedbackSuccess,
    requestCustomerMailAddresses,
    requestCustomerMailAddressesFailure,
    requestCustomerMailAddressesSuccess,
    requestCustomerPhoneNumbers,
    requestCustomerPhoneNumbersFailure,
    requestCustomerPhoneNumbersSuccess,
} from './actions';

/* Customer Mail Adresses */
function* fetchCustomerMailAddressesSaga(action: AnyAction): SagaIterator {
    yield put(requestCustomerMailAddresses());

    const { error, response } = yield call(fetchCustomerMailAddresses);

    if (error) yield put(requestCustomerMailAddressesFailure(error));
    else yield put(requestCustomerMailAddressesSuccess(response));
}

export function* generateFetchCustomerMailAddressesWatcher() {
    yield takeLatest(FETCH_CUSTOMER_MAIL_ADDRESSES, fetchCustomerMailAddressesSaga);
}

/* Customer Phone Numbers */
function* fetchCustomerPhoneNumbersSaga(action: AnyAction): SagaIterator {
    yield put(requestCustomerPhoneNumbers());

    const { error, response } = yield call(fetchCustomerPhoneNumbers);

    if (error) yield put(requestCustomerPhoneNumbersFailure(error));
    else yield put(requestCustomerPhoneNumbersSuccess(response));
}

export function* generateFetchCustomerPhoneNumbersWatcher() {
    yield takeLatest(FETCH_CUSTOMER_PHONE_NUMBERS, fetchCustomerPhoneNumbersSaga);
}

/* Customer Data */
function* fetchCustomerDataSaga(action: AnyAction): SagaIterator {
    yield put(requestCustomerData());

    const { error, response } = yield call(fetchCustomerData);

    if (error) yield put(requestCustomerDataFailure(error));
    else yield put(requestCustomerDataSuccess(response));
}

export function* generateFetchCustomerDataWatcher() {
    yield takeLatest(FETCH_CUSTOMER_DATA, fetchCustomerDataSaga);
}

/* Customer Feedback */
function* fetchCustomerFeedbackSaga(action: AnyAction): SagaIterator {
    yield put(requestCustomerFeedback());

    const { error, response } = yield call(fetchCustomerFeedback);

    if (error) yield put(requestCustomerFeedbackFailure(error));
    else yield put(requestCustomerFeedbackSuccess(response));
}

export function* generateFetchCustomerFeedbackWatcher() {
    yield takeLatest(FETCH_CUSTOMER_FEEDBACK, fetchCustomerFeedbackSaga);
}
